import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useActionSheet } from '@expo/react-native-action-sheet';

import { Color } from '../../styles';
import ExpenseFormItem from './ExpenseFormItem';
import {
  DEFAULT_MILEAGE_CATEGORY,
  DynamoDBFieldNames,
  MileageCategories,
} from '../../constants/ExpenseCategories';
import { expenseFieldHeight } from '../../styles/CommonProperties';
import { setExpenseValue } from '../../store/actions/expense';
import { selectExpenseStates } from '../../store/selectors/expense.selector';

const buildFlattedSubcategories = () => {
  return MileageCategories?.filter(
    (category) => category.CategoryId !== DEFAULT_MILEAGE_CATEGORY.CategoryId
  )
    .map((category) => category.SubCategories)
    .flat();
};

const translateCategories = (flattedSubcategories) => {
  return flattedSubcategories.map((subCategory) => subCategory.Name);
};

const MileageCalculationSelector = ({ isEditable, actionType, subTab }) => {
  const { showActionSheetWithOptions } = useActionSheet();
  const dispatch = useDispatch();
  const expenseStates = useSelector(selectExpenseStates)[actionType][subTab];

  const onChangeDropDownCategory = () => {
    const flattedSubcategories = buildFlattedSubcategories();
    const translatedCategories = translateCategories(flattedSubcategories);
    showActionSheetWithOptions(
      {
        options: [...translatedCategories, 'Cancel'],
        cancelButtonIndex: translatedCategories.length,
        containerStyle: styles.dropdownContainer,
      },
      (buttonIndex) => {
        if (buttonIndex !== translatedCategories.length) {
          const selectedSubCategory = flattedSubcategories[buttonIndex];
          dispatch(
            setExpenseValue({
              actionType,
              subTab,
              key: DynamoDBFieldNames.SELECTED_SUBCATEGORY,
              value: selectedSubCategory,
            })
          );
        }
      }
    );
  };

  return (
    <TouchableOpacity
      onPress={() => onChangeDropDownCategory()}
      disabled={!isEditable}
      style={{ height: expenseFieldHeight }}
    >
      <ExpenseFormItem
        label="Calculation"
        value={expenseStates[DynamoDBFieldNames.SELECTED_SUBCATEGORY]?.Name}
        isCaretDownIcon={isEditable}
        style={styles.bottomBorder}
        // icon="list"
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  dropdownContainer: {
    height: 300,
    backgroundColor: Color.accent,
  },
  bottomBorder: {
    borderBottomWidth: 0.4,
    borderColor: Color.formDividerColor,
  },
});

export default MileageCalculationSelector;
